export default __webpack_public_path__ + "static/media/dropdown-tail.07bd7f0e.svg";